import React, { useState, useEffect } from "react";
import { Grid, Paper } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { DatePickerInput } from "rc-datepicker";
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import Modal_Frame from "../../biztran_controls/Modal_Frame";
import Moment from "moment";
import UseFetchData from "../../../hooks/UseFetchData";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import Data_Grid from "../../biztran_controls/DataGrid";
import AddExpenseSheet from "../../ExpenseSheet/AddExpenseSheet";
const todate = new Date()
const fromdate = todate.getFullYear() - 1 + '/04/01';


const TravelRequestReport = () => {
  const [FromDate, setFromDate] = useState();
  const [defaultfromDate, setdefaultfromDate] = useState();
  const [ToDate, setToDate] = useState();
  const [defaultToDate, setdefaultToDate] = useState();
  const [isOpen, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [Count, setCount] = useState();
  const [Employee, setEmployee] = useState('');
  const [Manager, setManager] = useState('');
  const [TravelLocation, setTravelLocation] = useState('');
  const [Status, setStatus] = useState('');
  const [ExpenseID, setExpenseID] = useState('');
  const [response, fetchData] = UseFetchData();


  const onFromClear = () => {
    setFromDate();
    setdefaultfromDate();
  }

  function CustomToolbar() {
    return (
      <GridToolbarContainer style={{ marginLeft: '93%' }}>
        <GridToolbarExport csvOptions={{
          fields: ['TravelRequestNo', 'TravelRequestDate', 'EmpCode', 'EmpName', 'Locationto']
        }} />
      </GridToolbarContainer>
    );
  }

  const Statuscmb = [
    { id: "TR Requested", title: "TR Requested" },
    { id: "TR Approved", title: "TR Approved" },
    { id: "TR Rejected", title: "TR Rejected" },
    { id: "Travelling", title: "Travelling" },
    { id: "Exp Requested", title: "Exp Requested" },
    { id: "Exp Rejected", title: "Exp Rejected" },
    { id: "ACC Approved", title: "ACC Approved" },
    { id: "Paid", title: "Paid" },
  ];
  const onToClear = () => {
    setToDate();
    setdefaultToDate();
  }
  const openModal = (row) => {
    setOpen(true);
    setExpenseID(row.id);
  };

  const handleOpenModal = () => {
    setExpenseID('');
    setOpen(true);
  };

  const PopulateData = () => {
    debugger;
    var bodyFormData = new FormData();
    if (FromDate !== "" || FromDate !== null) {
      bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
    }
    else {
      bodyFormData.append("FromDate", "");
    }
    if (ToDate !== "" || ToDate !== null) {
      bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
    }
    else {
      bodyFormData.append("ToDate", "");
    }
    if (Employee !== "" || Employee !== null) {
      bodyFormData.append("EmpName", Employee);
    }
    else {
      bodyFormData.append("EmpName", "");
    }
    if (Manager !== "" || Manager !== null) {
      bodyFormData.append("Manager", Manager);
    }
    else {
      bodyFormData.append("Manager", "");
    }

    if (Status !== "" || Status !== null) {
      bodyFormData.append("ApprovalStatus", Status);
    }
    else {
      bodyFormData.append("ApprovalStatus", "");
    }
    if (TravelLocation !== "" || TravelLocation !== null) {
      bodyFormData.append("TravelLocation", TravelLocation);
    }
    else {
      bodyFormData.append("TravelLocation", "");
    }

    fetchData("Reports/TravelReport", bodyFormData);
  }

  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: "Select",
        //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
        renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        hide: true,
        width: 70,
      },
      {
        field: "TravelRequestNo",
        headerName: "Travel Request No",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "TravelRequestDate",
        headerName: "Travel Request Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "EmpCode",
        headerName: "Emp Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "EmpName",
        headerName: "Emp Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "LocationFromTravel",
        headerName: "Location From Travel",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "LocationToTravel",
        headerName: "Location To Travel",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "PurposeOfTravel",
        headerName: "Purpose Of Travel",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "FromDate",
        headerName: "From Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "ToDate",
        headerName: "To Date",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "ApprovalStatus",
        headerName: "Status",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "ApproxExpAmount",
        headerName: "Approx Exp Amount",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "ApprovedBy",
        headerName: "Mngr Approved By",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
    ];
    setColumns(gridCols);
    if (response.Main !== undefined) {
      debugger;
      setRows(response.Main);
      setCount(response.Main.length);
    }

  }, [response]
  );

  useEffect(() => {
    PopulateData();
  }, [])

  return (
    <div>
      <Paper elevation={0}>
        <Grid container="row">
          <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
            <div style={{ width: "198px", marginLeft: 10, marginTop: -3 }}>
              <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
              <DatePickerInput
                onChange={(jsDate, dateString) => setFromDate(dateString)}
                locale="en"
                displayFormat="DD/MMM/YYYY"
                className='my-react-component'
                onClear={() => { onFromClear(); }}
                showOnInputClick
                maxDate={new Date()}
                returnFormat="YYYY/MM/DD"
                defaultValue={defaultfromDate}
              >
              </DatePickerInput>
            </div>
          </Grid>
          <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
            <div style={{ width: "198px", marginLeft: 9, marginTop: -3 }}>
              <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
              <DatePickerInput
                onChange={(jsDate, dateString) => setToDate(dateString)}
                locale="en"
                displayFormat="DD/MMM/YYYY"
                className='my-react-component'
                onClear={() => { onToClear(); }}
                showOnInputClick
                maxDate={new Date()}
                returnFormat="YYYY/MM/DD"
                defaultValue={defaultToDate}
              >
              </DatePickerInput>
            </div>
          </Grid>
        </Grid>
        <br />
        <Grid container="row" marginTop={1} >
          <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
            <div style={{ width: "100%", marginLeft: 2, marginTop: 1 }} >
              <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                <BiztranControls.Input
                  label="Employee"
                  id="Employee"
                  onChange={(e) => setEmployee(e.target.value)}
                />
              </div>
            </div>
          </Grid>
          <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
            <div style={{ width: "100%", marginLeft: 0.5, marginTop: 1 }} >
              <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                <BiztranControls.Input
                  label="Manager"
                  id="Manager"
                  onChange={(e) => setManager(e.target.value)}
                />
              </div>
            </div>
          </Grid>
          <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: 20 }}>
            <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
          </div>
        </Grid>
        <Grid container direction="row" marginTop={10} style={{ paddingTop: 4 }}>
          <Grid xs={12} md={5} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
            <div style={{ width: "110%", marginLeft: 3, marginTop: 2 }} >
              <div style={{ float: "left", marginTop: 0, width: "40%" }}>
                <BiztranControls.Input
                  label="Travel Location"
                  id="TravelLocation"
                  onChange={(e) => setTravelLocation(e.target.value)}
                />
              </div>
            </div>
          </Grid>
          <Grid xs={12} md={2} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
            <div style={{ width: "110%", marginLeft: 2, marginTop: 2 }} >
              <div style={{ float: "left", marginTop: 0, width: "40%" }}>
                <BiztranControls.Select
                  label="Status"
                  id="Status"
                  options={Statuscmb}
                  onChange={(e) => setStatus(e.target.value)}
                />
              </div></div>
          </Grid>
          <Grid xs={6} md={4} sm={8} lg={4} xl={3} style={{ marginTop: 15 }} >
            <div style={{ width: "100%", marginLeft: 10, marginTop: 2 }} >
              <div style={{ float: "left", marginTop: 0, width: "30%" }}>
                <BiztranControls.Button
                  text="SEARCH"
                  startIcon={<SearchIcon />}
                  style={{ marginTop: '10%' }}
                  onClick={() => {
                    PopulateData();
                  }}
                />
              </div>
              {/* <div style={{ float: "left", marginTop: 0, paddingLeft: 5, width: "30%" }}>
                <BiztranControls.Button
                  text="ADD NEW"
                  startIcon={<AddCircleOutlineIcon />}
                  style={{ marginTop: '10%' }}
                  onClick={() => {
                    handleOpenModal();
                  }}
                />
              </div> */}

            </div>
          </Grid>
        </Grid>

        <Modal_Frame
          title="User Details"
          maxWidth="md"
          isOpen={isOpen}
          setOpen={setOpen}
        >
          <AddExpenseSheet
            ExpenseID={ExpenseID}
            setOpen={setOpen}
            PopulateData={PopulateData}
          />
        </Modal_Frame>

        <BiztranControls.DataGrid
          rowHeight={25}
          headerHeight={34}
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          // autoHeight={true}
          Width="107%"
          Height="400px"
          components={{ Toolbar: CustomToolbar, }}
          hideFooter={true}
        />
      </Paper>
    </div>
  )
}

export default TravelRequestReport;


// import React, { useState, useEffect } from "react";
// import { Grid, Paper } from '@material-ui/core';
// import SearchIcon from '@material-ui/icons/Search';
// import { DatePickerInput } from "rc-datepicker";
// import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
// import SaveIcon from '@material-ui/icons/Save';
// import CloseIcon from '@material-ui/icons/Close';
// import { Formik, Form } from 'formik';
// import Modal_Frame from "../../biztran_controls/Modal_Frame";
// import Moment from "moment";
// import UseFetchData from "../../../hooks/UseFetchData";
// import BiztranControls from "../../biztran_controls/BiztranControls";
// import Data_Grid from "../../biztran_controls/DataGrid";
// import AddExpenseSheet from "../../ExpenseSheet/AddExpenseSheet";
// const todate = new Date()
// const fromdate = todate.getFullYear() - 1 + '/04/01';


// const TravelRequestReport = () => {
//   const [FromDate, setFromDate] = useState(fromdate);
//   const [defaultfromDate, setdefaultfromDate] = useState(fromdate);
//   const [ToDate, setToDate] = useState(todate.toISOString());
//   const [defaultToDate, setdefaultToDate] = useState(todate);
//   const [isOpen, setOpen] = useState(false);
//   const [rows, setRows] = useState([]);
//   const [columns, setColumns] = useState([]);
//   const [Count, setCount] = useState();
//   const [Employee, setEmployee] = useState('');
//   const [Manager, setManager] = useState('');
//   const [TravelLocation, setTravelLocation] = useState('');
//   const [Status, setStatus] = useState('');
//   const [Statuscmb, setStatuscmb] = useState([]);
//   const [ExpenseID, setExpenseID] = useState('');
//   const [response, fetchData] = UseFetchData();


//   const onFromClear = () => {
//     setFromDate();
//     setdefaultfromDate();
//   }

//   const onToClear = () => {
//     setToDate();
//     setdefaultToDate();
//   }

//   const openModal = (row) => {
//     setOpen(true);
//     setExpenseID(row.id);
//   };

//   const handleOpenModal = () => {
//     setExpenseID('');
//     setOpen(true);
//   };

//   const PopulateData = () => {
//     var bodyFormData = new FormData();
//     bodyFormData.append("FromDate", Moment(FromDate).format('YYYY-MM-DD'));
//     bodyFormData.append("ToDate", Moment(ToDate).format('YYYY-MM-DD'));
//     fetchData("Reports/TravelRequestList", bodyFormData);
//   }

//   useEffect(() => {
//     const gridCols = [
//       {
//         field: "id",
//         headerName: "Select",
//         //renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
//         renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong>),
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 70,
//       },
//       {
//         field: "TravelRequestNo",
//         headerName: "Travel Request No",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "TravelRequestDate",
//         headerName: "Travel Request Date",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "EmpCode",
//         headerName: "Emp Code",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "EmpName",
//         headerName: "Emp Name",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "LocationToTravel",
//         headerName: "Location To Travel",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "PurposeOfTravel",
//         headerName: "Purpose Of Travel",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "FromDate",
//         headerName: "From Date",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },

//       {
//         field: "ToDate",
//         headerName: "To Date",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "ApproxExpAmount",
//         headerName: "Approx Exp Amount",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "ApprovedByID",
//         headerName: "Approved By",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },
//       {
//         field: "ApprovalStatus",
//         headerName: "Approval Status",
//         headerClassName: "super-app-theme--header",
//         headerAlign: "center",
//         width: 150,
//       },

//     ];
//     setColumns(gridCols);
//     setRows(response);
//     setCount(response.length);
//   }, [response]
//   );
//   useEffect(() => {
//     PopulateData();
//   }, [])
//   return (
//     <div>
//       <Paper elevation={0}>
//         <Grid container="row">
//           <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
//             <div style={{ width: "198px", marginLeft: 10, marginTop: -3 }}>
//               <label style={{ color: "grey", fontSize: 12 }}>From Date</label>
//               <DatePickerInput
//                 onChange={(jsDate, dateString) => setFromDate(dateString)}
//                 locale="en"
//                 displayFormat="DD/MMM/YYYY"
//                 className='my-react-component'
//                 onClear={() => { onFromClear(); }}
//                 showOnInputClick
//                 maxDate={new Date()}
//                 returnFormat="YYYY/MM/DD"
//                 defaultValue={defaultfromDate}
//               >
//               </DatePickerInput>
//             </div>
//           </Grid>
//           <Grid xs={12} md={2} sm={6} lg={2} xl={2} >
//             <div style={{ width: "198px", marginLeft: 9, marginTop: -3 }}>
//               <label style={{ color: "grey", fontSize: 12 }}>To Date</label>
//               <DatePickerInput
//                 onChange={(jsDate, dateString) => setToDate(dateString)}
//                 locale="en"
//                 displayFormat="DD/MMM/YYYY"
//                 className='my-react-component'
//                 onClear={() => { onToClear(); }}
//                 showOnInputClick
//                 maxDate={new Date()}
//                 returnFormat="YYYY/MM/DD"
//                 defaultValue={defaultToDate}
//               >
//               </DatePickerInput>
//             </div>
//           </Grid>
//         </Grid>
//         <br />
//         <Grid container="row" marginTop={1} >
//           <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
//             <div style={{ width: "100%", marginLeft: 2, marginTop: 1 }} >
//               <div style={{ float: "left", marginTop: 0, width: "30%" }}>
//                 <BiztranControls.Input
//                   label="Employee"
//                   id="Employee"
//                   onChange={(e) => setEmployee(e.target.value)}
//                 />
//               </div>
//             </div>
//           </Grid>
//           <Grid xs={12} md={2} sm={8} lg={2} xl={3} style={{ marginTop: 1 }} >
//             <div style={{ width: "100%", marginLeft: 0.5, marginTop: 1 }} >
//               <div style={{ float: "left", marginTop: 0, width: "30%" }}>
//                 <BiztranControls.Input
//                   label="Manager"
//                   id="Manager"
//                   onChange={(e) => setManager(e.target.value)}
//                 />
//               </div>
//             </div>
//           </Grid>
//           <div style={{ float: "left", width: 16, marginTop: 20, marginLeft: 20 }}>
//             <label style={{ fontWeight: 'bold', width: 16 }}>{Count}</label>
//           </div>
//         </Grid>

//         <Grid container direction="row" marginTop={10} style={{ paddingTop: 4 }}>
//           <Grid xs={12} md={5} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
//             <div style={{ width: "110%", marginLeft: 3, marginTop: 2 }} >
//               <div style={{ float: "left", marginTop: 0, width: "40%" }}>
//                 <BiztranControls.Input
//                   label="Travel Location"
//                   id="TravelLocation"

//                   onChange={(e) => setTravelLocation(e.target.value)}
//                 />
//               </div>
//             </div>
//           </Grid>
//           <Grid xs={12} md={2} sm={3} lg={2} xl={2} style={{ marginTop: 20 }}>
//             <div style={{ width: "110%", marginLeft: 2, marginTop: 2 }} >
//               <div style={{ float: "left", marginTop: 0, width: "40%" }}>
//                 <BiztranControls.Select
//                   label="Status"
//                   id="Status"
//                   options={Statuscmb}
//                   onChange={(e) => setStatus(e.target.value)}
//                 />
//               </div></div>
//           </Grid>
//           <Grid xs={6} md={4} sm={8} lg={4} xl={3} style={{ marginTop: 15 }} >
//             <div style={{ width: "100%", marginLeft: 10, marginTop: 2 }} >
//               <div style={{ float: "left", marginTop: 0, width: "30%" }}>
//                 <BiztranControls.Button
//                   text="SEARCH"
//                   startIcon={<SearchIcon />}
//                   style={{ marginTop: '10%' }}
//                   onClick={() => {
//                     PopulateData();
//                   }}
//                 />
//               </div>
//               {/* <div style={{ float: "left", marginTop: 0, paddingLeft: 5, width: "30%" }}>
//                 <BiztranControls.Button
//                   text="ADD NEW"
//                   startIcon={<AddCircleOutlineIcon />}
//                   style={{ marginTop: '10%' }}
//                   onClick={() => {
//                     handleOpenModal();
//                   }}
//                 />
//               </div> */}

//             </div>
//           </Grid>
//         </Grid>

//         <Modal_Frame
//           title="User Details"
//           maxWidth="md"
//           isOpen={isOpen}
//           setOpen={setOpen}
//         >
//           <AddExpenseSheet
//             ExpenseID={ExpenseID}
//             setOpen={setOpen}
//             PopulateData={PopulateData}
//           />
//         </Modal_Frame>

//         <BiztranControls.DataGrid
//           rowHeight={25}
//           headerHeight={34}
//           rows={rows}
//           columns={columns}
//           checkboxSelection={false}
//           autoHeight={true}
//           Width="107%"
//           Height="400px"
//           hideFooter={true}
//         />
//       </Paper>
//     </div>
//   )
// }

// export default TravelRequestReport;